export const AUTH_TOKEN_CACHE_KEY = 'CR_AUTH_TOKEN';

export const AUTH_REFRESH_TOKEN_CACHE_KEY = 'CR_AUTH_REFRESH_TOKEN';

/**
 * Minimal, non-sensitive UI metadata about an active impersonation (single atomic key so
 * `storage` events stay consistent across tabs). It is NOT an authority: it is only trusted while
 * a valid access token is present. Never store Superadmin tokens here or anywhere else.
 */
export const AUTH_IMPERSONATION_CACHE_KEY = 'CR_IMPERSONATION_SESSION';

/** Show the "impersonation ends soon" warning when this much time (ms) or less remains. */
export const IMPERSONATION_EXPIRY_WARNING_MS = 5 * 60 * 1000;

/** How often (ms) the banner re-evaluates the remaining impersonation time. */
export const IMPERSONATION_TICK_MS = 15 * 1000;
